import { render, staticRenderFns } from "./viewPurchase.vue?vue&type=template&id=6f5ebb80"
import script from "./viewPurchase.vue?vue&type=script&lang=js"
export * from "./viewPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports